export function isInputEmpty(value: string) {
  if (value === "" || value === null) {
    return { msg: "", success: false };
  } else {
    return { msg: "", success: true };
  }
}

export function validateEmail(mail: string) {
  const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

  if (!mail || mail.trim() === "") {
    return { msg: "Please enter email address", success: false };
  } else if (!emailRegex.test(mail)) {
    return { msg: "Please enter valid email address", success: false };
  }
  return { msg: "", success: true };
}

export function validateMobileNumber(number: string) {
  const mob = /^[6-9]\d{9}$/;

  if (!number || number.trim() === "") {
    return { msg: "Please enter mobile number", success: false };
  } else if (!mob.test(number)) {
    return { msg: "Invalid mobile number", success: false };
  }
  return { msg: "", success: true };
}
